import { createRouter, createWebHistory } from 'vue-router';
import HomeView from '@/views/HomeView.vue';
import Login from '@/views/Auth/Login.vue';
import MessagesView from '@/views/MessagesView.vue';
import ProjectsView from '@/views/ProjectsView.vue';
import CreateProjectView from '@/views/CreateProjectView.vue';

// route guard
import { projectAuth } from '@/firebase/config';
const requireAuth = (to, from, next) => {
  let user = projectAuth.currentUser;
  if (!user) {
    next({ name: 'Login' });
  } else {
    next();
  }
};

const routes = [
  {
    path: '/',
    name: 'Home',
    component: HomeView,
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
  },
  {
    path: '/messages',
    name: 'Messages',
    component: MessagesView,
    beforeEnter: requireAuth,
  },
  {
    path: '/projects',
    name: 'Projects',
    component: ProjectsView,
    beforeEnter: requireAuth,
  },
  {
    path: '/create',
    name: 'CreateProject',
    component: CreateProjectView,
    beforeEnter: requireAuth,
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
